import { interopDefault } from '~/router/utils'
import { Route } from 'vue-router/types/router'

export default [
  {
    name: '__detailed_search',
    path: '/classifieds/:category/search/:subCategory?',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/detailed-search.vue' /* webpackChunkName: "pages-car-classifieds-detailed-search" */
        )
      ),
    meta: {
      noFooter: 'mobile',
      hideMobileBottomMenu: true
    }
  },
  {
    name: '__detailed_search_parts_legacy',
    path: '/parts/search/:subCategory',
    redirect: (to: Route) => {
      return {
        name: '__detailed_search',
        params: {
          category: 'parts',
          subCategory: to.params.subCategory
        }
      }
    }
  }
]
